import {
  GoAHeroBanner,
} from "@abgov/react-components";
import * as React from "react";

interface INotFoundProps {}

const Unauthorized: React.FunctionComponent<INotFoundProps> = (props) => {
  return (
    <>
    <div className="unauthorized-label-container">
      <GoAHeroBanner heading="You don’t have permission to view this order."></GoAHeroBanner>
      </div>
    </>
  );
};

export default Unauthorized;
